import React from 'react'
import { Navigation } from '@griegconnect/krakentools-react-kraken-app'
import { withActiveTenant } from '@app/routes/WithActiveTenant'
import { withServices } from '@app/routes/withServices'
import { PATH_TENANT_BASE, Permissions, PERMISSIONS } from '@app/constants'
import { AccessDependencies } from '@app/Content'
import { requireAllGlobalPermissions } from '@app/lib/access'

const PATH = PATH_TENANT_BASE + '/settings/visy'
const visyActive = (d: AccessDependencies) => d.portConfig.visy

export const visyModuleNavs: Navigation.Item<AccessDependencies>[] = [
  {
    name: 'Visy',
    path: PATH + '/',
    page: React.createElement(withServices(withActiveTenant(React.lazy(() => import('./settings'))))),
    exact: true,
    menu: true,
    access: (d) => visyActive(d) && requireAllGlobalPermissions(Permissions.all(PERMISSIONS.global_access_system))(d),
  },
]
